import { ApiRequest, RequestMethod } from "../../request";

export async function removeProfile(
  fighterId: string,
  fighterWeaponId: string,
  profileId: string,
  refundMode: number
): Promise<boolean> {
    const URL = `/api/fighter/${fighterId}/fighter-weapon/remove-profile`;
  const apiRequest = new ApiRequest();
  apiRequest.setMethod(RequestMethod.DELETE);
  apiRequest.setUrl(URL);

  apiRequest.setJsonBody({
    fighterWeaponId: fighterWeaponId,
    profileId: profileId,
    refundMode: refundMode,
  });

  return (await apiRequest.send()).status === 200;
}
